import {updateUserDetailsAction, fetchUserDetails} from '@ibibo/user-reducer';

import {
  getRechargeStatus,
  getWalletData,
  getMyTripsData,
  getMyTripsDetailsData,
  getCancellationData,
  getCancellationRefundData,
  getConfirmCancellation,
  addWalletBalance,
  updateUserSetting,
  getMyTripsHotelData,
  getMyTripsModifyData,
  confirmReschedule,
  updateUserName,
  updateAadharNo,
  getNeftDetails,
  updateEmail,
  unlinkMobile,
  unMask,
  mask,
  updateMobile,
  getLoyaltyDetails,
  sendAgreement,
  getEmailVerify,
  getVerifiedEmailUpdate,
  updateEmailOtp,
  getRefundRaiseRequestListing,
  sendRefundRaiseRequest,
  postUpdateTdsSlab,
  getGstInvoiceData,
  getGstPdf,
  getRequest,
  postRequest,
  submitLicenseDetailsCall,
  updateName,
} from '@ibibo/my-account-apis';

import {
  updateRechargeStatus,
  updateWalletData,
  updateWalletBreakupData,
  updateMyTripsLoader,
  updateWalletStatementLoader,
  updateMyTripsData,
  updateMyTripsDetailsData,
  updateCancellationData,
  updateCancellationRefundData,
  updateUserSettingData,
  updateMyTripsModifyHotelDetailsData,
  updateMyTripsModifyDetailsData,
  updateModifyStatus,
  updateSuccessNameMessage,
  updateErrorNameMessage,
  updateAadharNumberAction,
  updateNeftDetailsLoaderAction,
  getLoyaltyAgreementDate,
  getLoyaltyAgreementDoc,
  updateGccUserSettingData,
  updateFormFieldsData,
} from './myaccount-actions';

import {
  walletApi,
  walletBreakupApi,
  rechargeWalletApi,
  myTripsApi,
  cancellationApi,
  refundAmountApi,
  confirmCancellation,
  settingApi,
  myTripsModifyApi,
  myTripsModifyHotelDetailsApi,
  confirmRescheduleApi,
  rescheduleStatusApi,
  refundDetailsApi,
  nameChangeApi,
  aadharApi,
  neftApi,
  emailVerifyApi,
  unlinkMobileApi,
  updateMobileApi,
  getLoyaltyAgnApi,
  getEmailVerifyApi,
  updateVerifiedEmail,
  refundRaiseRequestListing,
  refundRaiseRequest,
  updateTdsSlabUrl,
  gccMyProfile,
  getUserAgnApi,
  getGstinDetails,
  commissionBreakupApi,
  commsionInvoiceDocumentUpload,
  commsionInvoiceDetails,
  trackCommissionReport,
  UPDATE_LICENSE_DETAILS,
  DOWNLOAD_CREDIT_MEMO,
  unMaskOTPApi,
  verifyUnMaskOTPApi,
  maskDataApi,
  updateNameApi,
} from './myaccount-constants';

import {
  toggleLoadingUserDetailsAction,
  toggleEmailLoding,
  toggleSendOtpLoading,
} from '../../../packages/user-reducer/src/user-actions';

export const rechargeWallet = (wallet_txn_amount, successCallback, errorCallback) => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${rechargeWalletApi}`;
      addWalletBalance({
        url,
        data: {
          wallet_txn_amount,
        },
      }).then(response => {
        if (response && response.success) {
          successCallback(response);
        } else {
          errorCallback();
        }
      });
    } catch {
      errorCallback();
    }
  };
};

export const getWalletRechargeStatus = searchQuery => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      let i = 0;
      let calltype = '';
      searchQuery.forEach(function(value, key) {
        calltype = value;
      });
      if (calltype === 'success') {
        dispatch(
          updateRechargeStatus({
            msg: 'Awesome! Balance updated successfully',
            success: true,
          }),
        );
      } else {
        dispatch(
          updateRechargeStatus({
            msg: 'Sorry! Balance not updated successfully. Please try after sometime.',
            success: false,
          }),
        );
      }
    } catch {}
  };
};

export const fetchWalletData = (data?) => {
  return async (dispatch, getState) => {
    dispatch(updateWalletStatementLoader(true));
    try {
      const {myaccount} = getState();
      const statementType = myaccount?.walletType;
      let url = `${walletApi}promo-wallet-transaction?statement_type=${statementType}`;
      if (data && data.startDate && data.endDate) {
        url += `&start_date=${data.startDate}&end_date=${data.endDate}`;
      }
      getWalletData({url})
        .then(response => {
          if (response && response.data) {
            dispatch(updateWalletData({walletData: response.data, loading: false}));
          }
        })
        .catch(() => {
          dispatch(updateWalletData({walletData: [], loading: false}));
        });
    } catch {}
  };
};

export const fetchWalletBrekupData = () => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${walletBreakupApi}`;
      getWalletData({url})
        .then(response => {
          if (response && response.data) {
            dispatch(updateWalletBreakupData({walletBreakupData: response.data, loading: false}));
          }
        })
        .catch(() => {
          dispatch(
            updateWalletBreakupData({
              walletBreakupData: {
                promo_balance: 0,
                total_balance: 0,
                wallet_balance: 0,
                incentive_amount: 0,
              },
              loading: false,
            }),
          );
        });
    } catch {}
  };
};

export const fetchMyTripsData = () => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${myTripsApi}`;
      getMyTripsData({url}).then(response => {
        if (response && response.success) {
          dispatch(updateMyTripsData({...response, loading: false}));
        }
      });
    } catch {}
  };
};

export const fetchMyTripsDetailsData = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${myTripsApi}${detailsParams.parentID}_${detailsParams.mobile}/?searchid=${detailsParams.childID}_${detailsParams.mobile}`;
      getMyTripsDetailsData({url}).then(response => {
        if (response && response.success) {
          dispatch(updateMyTripsDetailsData({...response, loading: false}));
        }
      });
    } catch {}
  };
};

export const fetchMyTripNameChangeData = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${myTripsApi}${detailsParams.parentID}_${detailsParams.mobile}/?searchid=${detailsParams.childID}_${detailsParams.mobile}`;
      getMyTripsDetailsData({url}).then(response => {
        if (response && response.success) {
          dispatch(updateMyTripsDetailsData({...response, loading: false}));
        }
      });
    } catch {}
  };
};

export const fetchRefundData = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${refundDetailsApi}${detailsParams.parentID}`;
      getCancellationData({url}).then(response => {
        if (response) {
          dispatch(updateCancellationData({data: response, loading: false}));
        }
      });
    } catch {}
  };
};

// /api/v1/hotels/refund_amount?bookingid=GOHTLIB2BFKEH3AG'
export const fetchCancellationData = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${cancellationApi}?bookingid=${detailsParams.parentID}`;
      getCancellationData({url}).then(response => {
        if (response) {
          dispatch(updateCancellationData({data: response, loading: false}));
        }
      });
    } catch {}
  };
};

export const fetchCancellationRefundData = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${refundAmountApi}`;
      getCancellationRefundData({url, data: {bookingid: detailsParams.parentID}}).then(response => {
        if (response) {
          dispatch(updateCancellationRefundData({refundData: response, loading: false}));
        }
      });
    } catch {}
  };
};

export const confirmCancellationApi = (detailsParams, paymode, successCallback, errCallback) => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${confirmCancellation}`;
      getConfirmCancellation({
        url,
        data: {
          bookingid: detailsParams.parentID,
          paymode,
        },
      }).then(response => {
        if (response) {
          if (response.success) {
            successCallback(response);
          } else {
            errCallback(response);
          }
        } else {
          errCallback({success: false});
        }
      });
    } catch {
      errCallback({success: false});
    }
  };
};

export const fetchModifyHotelDetails = detailsParams => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${myTripsModifyHotelDetailsApi}?booking_id=${detailsParams.parentID}`;
      getMyTripsHotelData({url}).then(response => {
        if (response && response.success) {
          dispatch(updateMyTripsModifyHotelDetailsData({...response, loading: false}));
        }
      });
    } catch {}
  };
};

export const fetchModifyDetails = queryStr => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${myTripsModifyApi}?${queryStr}`;
      getMyTripsModifyData({url}).then(response => {
        if (response) {
          dispatch(updateMyTripsModifyDetailsData({...response, loading: false}));
        }
      });
    } catch {}
  };
};

export const confirmAmmendment = (data, query, successCallback, errCallback) => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      const url = `${confirmRescheduleApi}?${query}`;
      confirmReschedule({url, data}).then(response => {
        if (response) {
          if (response.success) {
            successCallback(response);
          } else {
            errCallback(response);
          }
        } else {
          errCallback({success: false});
        }
      });
    } catch {
      errCallback({success: false});
    }
  };
};

export const getRescheduleStatus = searchQuery => {
  return async dispatch => {
    dispatch(updateMyTripsLoader(true));
    try {
      let params = '';
      let i = 0;
      searchQuery.forEach(function(value, key) {
        if (i > 0) {
          params += '&';
        }
        params += `${key}=${value}`;
        i++;
      });
      const url = `${rescheduleStatusApi}?${params}`;
      getRechargeStatus({url, name: 'reschedule status api'}).then(response => {
        if (response && response.data) {
          dispatch(
            updateModifyStatus({
              amended: response.data.amended || false,
              msg: response.data.message || '',
              sub_msg: response.data.sub_msg || '',
              status_color: response.status_color || 'yellow',
            }),
          );
        } else {
          dispatch(
            updateModifyStatus({
              amended: false,
              msg: 'Something Went Wrong',
              sub_msg: '',
              status_color: response.status_color || 'red',
            }),
          );
        }
      });
    } catch {
      dispatch(
        updateModifyStatus({
          amended: false,
          msg: 'Something Went Wrong',
          sub_msg: '',
          status_color: 'red',
        }),
      );
    }
  };
};

export const setUserSetting = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${settingApi}`;
      updateUserSetting({url, data: data}).then(response => {
        if (response && response.success && response.data && response.data.user_info) {
          dispatch(
            updateUserDetailsAction({
              userInfo: response.data.user_info,
              data_masked: response?.data?.data_masked,
            }),
          );
          successCallback(response);
        } else {
          errorCallback();
        }
      });
    } catch {
      errorCallback();
    }
  };
};

export const getUserSetting = (successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${settingApi}`;
      getRefundRaiseRequestListing({url}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
          dispatch(
            updateUserDetailsAction({
              userInfo: response.data?.user_info,
              personal_profile: response.data?.personal_profile,
            }),
          );
        } else {
          errorCallback('error');
        }
        //dispatch(toggleSendOtpLoading(false));
      });
    } catch {
      errorCallback();
    }
  };
};

export const setGccUserSetting = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${gccMyProfile}`;
      updateUserSetting({url, data: data}).then(response => {
        if (response && response.success && response.data && response.data.user_info) {
          dispatch(
            updateUserDetailsAction({
              userInfo: response.data.user_info,
            }),
          );
          successCallback(response);
        } else {
          errorCallback();
        }
      });
    } catch {
      errorCallback();
    }
  };
};

export const changeUserName = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${nameChangeApi}`;
      updateUserName({url, data: data}).then(response => {
        if (response && response.success && response.message) {
          successCallback(response);
        } else {
          errorCallback(response);
        }
      });
    } catch {
      errorCallback();
    }
  };
};

export const updateAadharNumber = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      dispatch(toggleLoadingUserDetailsAction(true));

      const url = `${aadharApi}`;
      updateAadharNo({url, data: data}).then(response => {
        if (response && response.success && response.data.aadhar_number.success) {
          dispatch(fetchUserDetails());
          dispatch(
            updateAadharNumberAction({
              aadharData: response.data,
            }),
          );
          successCallback(response.data);
        } else {
          errorCallback(response.data);
        }
        dispatch(toggleLoadingUserDetailsAction(false));
      });
    } catch {
      dispatch(toggleLoadingUserDetailsAction(false));
      errorCallback();
    }
  };
};

export const submitAadharOTP = (data, successCallOtp, errorCallOtp, errorCallback = () => {}) => {
  return async dispatch => {
    try {
      dispatch(toggleLoadingUserDetailsAction(true));

      const url = `${aadharApi}`;
      updateAadharNo({url, data: data}).then(response => {
        if (response && response.success && response.data.aadhar_number.success) {
          dispatch(fetchUserDetails());
          successCallOtp(response.data);
        } else {
          errorCallOtp(response.data);
        }
        dispatch(toggleLoadingUserDetailsAction(false));
      });
    } catch {
      dispatch(toggleLoadingUserDetailsAction(false));
      errorCallback();
    }
  };
};

export const getNeftRechargeDetails = (successCallback, errorCallback) => {
  return async dispatch => {
    try {
      dispatch(updateNeftDetailsLoaderAction(true));
      const url = `${neftApi}`;
      getNeftDetails({url}).then(response => {
        if (response && response.success && response.data) {
          successCallback(response.data);
          dispatch(updateNeftDetailsLoaderAction(false));
        } else {
          errorCallback();
        }
        dispatch(updateNeftDetailsLoaderAction(false));
      });
    } catch {
      dispatch(updateNeftDetailsLoaderAction(false));
      errorCallback();
    }
  };
};

export const updateEmailId = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      dispatch(toggleEmailLoding(true));
      const url = `${emailVerifyApi}`;
      updateEmail({url, data: data}).then(response => {
        if (response && response.success) {
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
        dispatch(toggleEmailLoding(false));
      });
    } catch {
      dispatch(toggleEmailLoding(false));
      errorCallBack();
    }
  };
};

export const verifyEmailId = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      dispatch(toggleEmailLoding(true));
      const url = `${getEmailVerifyApi}`;
      updateEmail({url, data: data}).then(response => {
        if (response && response.success) {
          dispatch(fetchUserDetails());
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
        dispatch(toggleEmailLoding(false));
      });
    } catch {
      dispatch(toggleEmailLoding(false));
      errorCallBack();
    }
  };
};

export const unlinkMobileNo = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${unlinkMobileApi}`;
      unlinkMobile({url, data: data}).then(response => {
        if (response && response.success) {
          dispatch(fetchUserDetails());
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
      });
    } catch {
      errorCallBack();
    }
  };
};
export const unMaskDataOTP = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${unMaskOTPApi}`;
      unMask({url, data: data}).then(response => {
        if (response && response.success) {
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
      });
    } catch {
      errorCallBack();
    }
  };
};
export const verifyUnMaskDataOTP = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${verifyUnMaskOTPApi}`;
      unMask({url, data: data}).then(response => {
        if (response && response.success) {
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
      });
    } catch {
      errorCallBack();
    }
  };
};
export const maskData = (successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${maskDataApi}`;
      mask({url}).then(response => {
        if (response && response.success) {
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
      });
    } catch {
      errorCallBack();
    }
  };
};

export const updateMobileNo = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      dispatch(toggleSendOtpLoading(true));
      const url = `${updateMobileApi}`;
      updateMobile({url, data: data}).then(response => {
        if (response && response.success) {
          dispatch(fetchUserDetails());
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
        dispatch(toggleSendOtpLoading(false));
      });
    } catch {
      dispatch(toggleSendOtpLoading(false));
      errorCallBack();
    }
  };
};

export const updateAgentName = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${updateNameApi}`;
      updateName({url, data: data}).then(response => {
        if (response?.success) {
          dispatch(fetchUserDetails());
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
      });
    } catch {
      errorCallBack();
    }
  };
};

export const fetchLoyaltyDateData = (successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${getUserAgnApi}`;
      getLoyaltyDetails({url}).then(response => {
        dispatch(
          getLoyaltyAgreementDate({
            loyaltyAgreementDate: response,
          }),
        );
      });
    } catch {}
  };
};

export const agreementAcceptanceRequest = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      //const url = `${getLoyaltyAgnApi}`;
      const url = `${getUserAgnApi}`;
      const obj = {agn_accept: data};
      sendAgreement({url, data: obj})
        .then(response => {
          successCallback();
        })
        .then(err => console.log(err));
    } catch {}
  };
};

export const termsPageRequest = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${getUserAgnApi}`;
      const obj = {doc_type: 'termination_agn'};
      sendAgreement({url, data: obj}).then(response => {
        if (response) {
          dispatch(
            getLoyaltyAgreementDoc({
              loyaltyAgreementDate: response,
            }),
          );
          successCallback(response);
        } else {
          errorCallback(response);
        }
      });
    } catch {}
  };
};

export const agreementPageRequest = (data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${getUserAgnApi}`;
      const obj = {doc_type: 'loyalty_agn'};
      sendAgreement({url, data: obj}).then(response => {
        if (response) {
          dispatch(
            getLoyaltyAgreementDoc({
              loyaltyAgreementDate: response,
            }),
          );
          successCallback(response);
        } else {
          errorCallback(response);
        }
      });
    } catch {}
  };
};

export const emailVerify = (successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${getEmailVerifyApi}`;
      getEmailVerify({url})
        .then(response => {
          if (response) {
            successCallBack(response);
          } else {
            errorCallBack(response);
          }
        })
        .then(err => console.log(err));
    } catch {}
  };
};

export const verifyUpdatedEmail = (email, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      const url = `${updateVerifiedEmail}?&email_id=${email}`;
      getVerifiedEmailUpdate({url})
        .then(response => {
          if (response.success) {
            successCallBack(response);
          } else {
            errorCallBack(response);
          }
        })
        .then(err => console.log(err));
    } catch {}
  };
};

export const verifyUpdatedEmailOtp = (data, successCallBack, errorCallBack) => {
  return async dispatch => {
    try {
      dispatch(toggleSendOtpLoading(true));
      const url = `${updateVerifiedEmail}`;
      updateEmailOtp({url, data: data}).then(response => {
        if (response && response.success) {
          successCallBack(response);
        } else {
          errorCallBack(response);
        }
        //dispatch(toggleSendOtpLoading(false));
      });
    } catch {
      //dispatch(toggleSendOtpLoading(false));
      errorCallBack();
    }
  };
};

export const getRefudRaiseRequest = (searchDates, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${refundRaiseRequestListing}${searchDates?.startDate}&searchEndDate=${searchDates?.endDate}`;
      getRefundRaiseRequestListing({url}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
        } else {
          errorCallback('error');
        }
        //dispatch(toggleSendOtpLoading(false));
      });
    } catch {
      //dispatch(toggleSendOtpLoading(false));
      //errorCallBack();
    }
  };
};

export const postRefundRaiseRequest = (raiseRequestFormData, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${refundRaiseRequest}`;
      const data = raiseRequestFormData;

      sendRefundRaiseRequest({url, data})
        .then(response => {
          if (response && response?.success) {
            successCallback(response?.data);
          } else {
            errorCallback(response?.message);
          }
          //dispatch(toggleSendOtpLoading(false));
        })
        .then(err => console.log(err));
    } catch {
      //dispatch(toggleSendOtpLoading(false));
      //errorCallBack();
    }
  };
};

export const getGccMyProfile = (successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${gccMyProfile}`;
      getRefundRaiseRequestListing({url}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
          dispatch(
            updateUserDetailsAction({
              userInfo: response.data?.user_info,
              personal_profile: response.data?.personal_profile,
            }),
          );
        } else {
          errorCallback('error');
        }
        //dispatch(toggleSendOtpLoading(false));
      });
    } catch {
      //dispatch(toggleSendOtpLoading(false));
      //errorCallBack();
    }
  };
};

export const updateTdsSlab = (successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${updateTdsSlabUrl}`;

      postUpdateTdsSlab({url})
        .then(response => {
          if (response && response?.success) {
            successCallback(response);
          } else {
            errorCallback(response?.message);
          }
          //dispatch(toggleSendOtpLoading(false));
        })
        .then(err => console.log(err));
    } catch {
      errorCallback();
    }
  };
};

export const getGstInvoice = (dateObject, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const url = `${getGstinDetails}`;
      getGstInvoiceData({url, data: dateObject}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
        } else {
          errorCallback(response);
        }
      });
    } catch {}
  };
};

export const downloadGstPdf = url => {
  return async dispatch => {
    try {
      getGstPdf({url}).then(response => {
        if (response && response?.success) {
        } else {
        }
      });
    } catch {}
  };
};

export const getCommissionBreakupData = (
  date,
  resubmit = false,
  bolt_rejected,
  successCallback,
  errCallback,
) => {
  return async dispatch => {
    try {
      let url = '';
      if (resubmit) {
        if (bolt_rejected) {
          url = `${commissionBreakupApi}${date?.start_date}&end_date=${date?.end_date}&resubmit_call=${resubmit}&bolt_rejected=${bolt_rejected}`;
        } else
          url = `${commissionBreakupApi}${date?.start_date}&end_date=${date?.end_date}&resubmit_call=${resubmit}`;
      } else url = `${commissionBreakupApi}${date?.start_date}&end_date=${date?.end_date}`;
      getGstPdf({url}).then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          errCallback(response);
        }
      });
    } catch (err) {
      errCallback(err);
    }
  };
};

export const submitCommissionInvoiceDocument = (data, successCallback, errCallback) => {
  return async dispatch => {
    try {
      const url = `${commsionInvoiceDocumentUpload}`;
      getGstInvoiceData({url, data}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
        } else {
          errCallback(response);
        }
      });
    } catch {
      const msg = 'Something went wrong. Please Upload again.';
      errCallback({
        message: msg,
      });
    }
  };
};

export const submitCommissionInvoiceDetails = (data, successCallback, errCallback) => {
  return async dispatch => {
    try {
      const url = `${commsionInvoiceDetails}`;
      getGstInvoiceData({url, data}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
        } else {
          errCallback(response);
        }
      });
    } catch {}
  };
};

export const trackSubmitCommissionInvoice = (data, successCallback, errCallback) => {
  return async dispatch => {
    try {
      const url = `${trackCommissionReport}`;
      getGstInvoiceData({url, data}).then(response => {
        if (response && response?.success) {
          successCallback(response?.data);
        } else {
        }
      });
    } catch {}
  };
};

export const makeGetRequest = (url, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      getRequest({url}).then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          errorCallback(response);
        }
      });
    } catch {}
  };
};

export const downloadCreditMemoReport = (url, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      const downloadUrl = `${DOWNLOAD_CREDIT_MEMO}?${url}`;
      getRequest({url: downloadUrl}).then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          errorCallback(response);
        }
      });
    } catch {}
  };
};

export const makePostRequest = (url, data, successCallback, errorCallback) => {
  return async dispatch => {
    try {
      postRequest({url, data}).then(response => {
        if (response?.success) {
          successCallback(response, data);
        } else {
          errorCallback(response, data);
        }
      });
    } catch {}
  };
};
//GCC Onboarding api for uploading licnese doc and license number
export const submitLicenseDetails = (data, successCallback, errorCallback) => {
  let fd = new FormData();
  for (const key in data) {
    fd.append(key, data[key]);
  }

  return (dispatch, getState) => {
    submitLicenseDetailsCall({
      url: UPDATE_LICENSE_DETAILS,
      data: fd,
    })
      .then(response => {
        if (response && response?.success) {
          successCallback(response);
        } else {
          const errorObj = {
            msg: response?.message || 'Error! Please try after sometime.',
            screen: 'verify',
            is_editable: response?.is_editable,
          };
          errorCallback(errorObj);
        }
      })
      .catch(() => {
        const errorObj = {
          msg: 'Error! Please try after sometime.',
          screen: 'verify',
        };
        errorCallback(errorObj);
      });
  };
};
